import { useTranslation } from "react-i18next";
import type { ItemChange } from "../../../api/content/reviewDecoders";
import { useItemVersionPair } from "../../items/changes/useItemVersionPair";
import SourceDiff from "../../../ui/content/source/SourceDiff";
import { definitionFieldText } from "../diff/textFields";
import LoadStatus from "../../../ui/feedback/LoadStatus";

/**
 * The changed text fields of a prompt, skill or artifact as line diffs between the previous
 * and the proposed version. An added item diffs against nothing, a removed one to nothing.
 */
export default function TextFieldDiffs({ item, fields }: { item: ItemChange; fields: readonly string[] }) {
  const { t } = useTranslation();
  const { state, reload } = useItemVersionPair(item);
  if (state.status !== "loaded") return <LoadStatus state={state} loadingLabel={t("reviews.item.loadingText")} onRetry={reload} compact />;
  const { before: oldVersion, after: newVersion } = state.value;
  return (
    <div className="space-y-2">
      {fields.map((field) => {
        const label = t(`reviews.item.textFields.${field}`);
        return (
          <div key={field}>
            <h4 className="app-subsection-title text-sm">{label}</h4>
            <SourceDiff
              label={label}
              language="markdown"
              original={definitionFieldText(oldVersion?.definition ?? null, field)}
              modified={definitionFieldText(newVersion?.definition ?? null, field)}
              presentation="full"
            />
          </div>
        );
      })}
    </div>
  );
}
